import React, {useState} from 'react';
import {v4 as uuid} from 'uuid';
import styled from 'styled-components';
import OuterLink from './OuterLink';
import Img from './Img';
import {MenuStyles} from '../styles';
import ScrollLink from './ScrollLink';
import {menu} from '../data';
import {headerBreakPoint} from '../styles/var';
import clsx from 'clsx';
import BurgerButton from './BurgerButton';

// images
import logo from '../asset/img/01-logo.png';
import img_more_odd from '../asset/img/expand_more_odd.svg';
import img_more_even from '../asset/img/expand_more_even.svg';


const HeaderStyles = styled.header`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--primary);
  margin-bottom: 1rem;
  position: relative;
  .menu-btn {
    position: fixed;
    z-index: 10000;
  }

  .logo {
    max-width: 25rem;
    margin-bottom: 1rem;
  }

  @media (min-width: ${headerBreakPoint.min}) {
    padding-top: 2rem;
    .menu-btn {
      display: none;
    }
  }
  @media (max-width: ${headerBreakPoint.max}) {
    padding-top: 1rem;
    .menu-btn {
      top: 0;
      right: 0;
    }

    .logo {
      max-width: 14rem;
    }
  }
`
const MainMenuStyles = styled.div`
  z-index: var(--level1);
  @media (min-width: ${headerBreakPoint.min}) {
    width: 100%;
    background-color: white;
    padding: 1rem 2rem;
    .menu-wrap {
      justify-content: center;
      gap: 1.5rem;
    }
  }
  @media (max-width: ${headerBreakPoint.max}) {
    display: none;
    --bg: var(--white);
    background-color: #FDD7DA;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10000;
    place-content: center;
    &.show {
      display: grid;
    }

    .menu-wrap {
      flex-direction: column;
      flex-wrap: nowrap;
      align-items: center;

      > .link-item {
        width: 100%;
        background-color: var(--bg);
        margin: 1rem 0;
        &:nth-child(odd) {
          --bg: var(--primary);
          > a {
            color: white;
          }
        }
        &:nth-child(even) {
          --bg: white;
          > a {
            color: var(--secondary);
            &::after {
              background-image: url(${img_more_even});
            }
          }

        }
      }
    }
  }
`
const MenuItemStyles = styled.li`
  @media (min-width: ${headerBreakPoint.min}) {
    > a {
      padding: 2px 2rem;
      background-color: var(--white);
    }
  }
  @media (max-width: ${headerBreakPoint.max}) {
    margin-bottom: 1rem;
    > a {
      color: var(--white);
      padding: .8rem 1.5rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-width: 20rem;

      &::after {
        content: '';
        display: inline-block;
        width: 2rem;
        height: 2rem;
        background: url(${img_more_odd}) no-repeat center center / contain;
        margin-left: 2rem;
      }
    }
  }
`;

const Header = () => {
  const [isShow, setIsShow] = useState(false);
  const handleClick = () => {
    setIsShow(prev => !prev);
  }
  const handleClose = () => {
    setIsShow(false);
  }
  return (
    <HeaderStyles id="header">
      <ScrollLink to="header" title="京城之霜">
        <Img src={logo} wrapProps={{className: "logo"}}/>
      </ScrollLink>
      <MainMenuStyles id="menu" className={clsx('animate__faster', {
        show: isShow,
        animate__animated: isShow,
        animate__fadeInDown: isShow
      })}>
        <MenuStyles justifyContent="flex-end" className='menu-wrap'>
          {menu.map(({text, to}) => (
            <MenuItemStyles key={uuid()} className="link-item">
              <ScrollLink to={to} onClick={handleClose}>{text}</ScrollLink>
            </MenuItemStyles>
          ))}
        </MenuStyles>
      </MainMenuStyles>
      <BurgerButton className="menu-btn" isShow={isShow} onClick={handleClick}/>
    </HeaderStyles>
  )
}

export default Header;
